"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ReadEmailCircle: ['read-email-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M5.250 6.750 L18.750 6.750 L18.750 17.250 L5.250 17.250 Z', 'M5.25 8.25L12 12 18.75 8.25']],
  ReadEmailAt1: ['read-email-at-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M15,18.048A6.751,6.751,0,1,1,18.75,12', 'M9.000 12.000 A3.000 3.000 0 1 0 15.000 12.000 A3.000 3.000 0 1 0 9.000 12.000 Z', 'M15,12v1.125a1.875,1.875,0,0,0,3.75,0V12']],
  ReadEmailMonitor: ['read-email-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15 22.5L9 22.5 9.75 18 14.25 18 15 22.5z', 'M6.75 22.5L17.25 22.5', 'M0.750 1.500 L23.250 1.500 L23.250 18.000 L0.750 18.000 Z', 'M6.750 6.000 L17.250 6.000 L17.250 13.500 L6.750 13.500 Z', 'M7.13 6.503L12 10.5 16.869 6.504']],
  ReadEmailLetter: ['read-email-letter', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 11.250 L21.750 11.250 L21.750 23.250 L2.250 23.250 Z', 'M18.75,11.25v-9a1.5,1.5,0,0,0-1.5-1.5H6.75a1.5,1.5,0,0,0-1.5,1.5v9', 'M8.25 3.75L12.75 3.75', 'M8.25 6.75L15.75 6.75', 'M15.75 14.25H18.75V17.25H15.75z', 'M5.25 14.25L8.25 14.25', 'M5.25 20.25L11.25 20.25']],
  ReadEmailAt: ['read-email-at', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,12A5.25,5.25,0,1,1,12,6.75,5.25,5.25,0,0,1,17.25,12Z', 'M17.25,12v2.25a3,3,0,0,0,6,0V12a11.249,11.249,0,1,0-4.5,9']],
  ReadEmailLaptop: ['read-email-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.750 1.500 L20.250 1.500 L20.250 15.000 L3.750 15.000 Z', 'M21.748,22.5H2.252A1.5,1.5,0,0,1,.91,20.329l1.836-3.671A3,3,0,0,1,5.429,15H18.571a3,3,0,0,1,2.683,1.658l1.836,3.671A1.5,1.5,0,0,1,21.748,22.5Z', 'M9.75 19.5L14.25 19.5', 'M6.750 4.500 L17.250 4.500 L17.250 12.000 L6.750 12.000 Z', 'M7.13 5.003L12 9 16.869 5.004']],
  ReadEmailHand: ['read-email-hand', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,15l-1.673-1.255a1.569,1.569,0,0,0-2.247.385h0a1.569,1.569,0,0,0,0,1.74l1.645,2.467A4.5,4.5,0,0,0,16.3,20.019L18.75,21v2.25', 'M15.75,9.75l3.6,1.541a4.5,4.5,0,0,1,2.363,2.364L22.886,16.4a4.5,4.5,0,0,1,.364,1.773V23.25', 'M15.75,14.437V8.25L8.25,12,.75,8.25v7.5a1.5,1.5,0,0,0,1.5,1.5H13.5', 'M14.25,9V2.25a1.5,1.5,0,0,0-1.5-1.5h-9a1.5,1.5,0,0,0-1.5,1.5V9', 'M5.25 3.75L9 3.75', 'M5.25 6.75L11.25 6.75']],
  ReadEmailTarget: ['read-email-target', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.750 8.250 L17.250 8.250 L17.250 15.750 L6.750 15.750 Z', 'M6.75 9.75L12 12.75 17.25 9.75', 'M5.25 18.75L0.75 23.25', 'M18.75 18.75L23.25 23.25', 'M5.25 5.25L0.75 0.75', 'M18.75 5.25L23.25 0.75', 'M21.789,17.547a11.261,11.261,0,0,0,0-11.094', 'M6.453,21.789a11.261,11.261,0,0,0,11.094,0', 'M2.211,6.453a11.261,11.261,0,0,0,0,11.094', 'M17.547,2.211a11.261,11.261,0,0,0-11.094,0']]
};
exports["default"] = _default;